import { useState, useCallback } from "react";
import useRequireAuth from "../../utils/useRequireAuth";

const useDataInputHandlerCopy = (fetchtableBodyData, setActiveCell, setClientCoord) => {
  const user = useRequireAuth();

  const handleDataInput = useCallback(
    async (rowId, item, columnKey, event) => {
      const columnId = columnKey.id;
      if (rowId?.label) {
        rowId = rowId?.label;
      }

      setActiveCell({ rowId, columnId });
      let rect = {};
      if (event && event.target) {
        let clickedElement;
        if (event.target.closest("td")) {
          clickedElement = event.target.closest("td");
        } else {
          clickedElement = event.target;
        }
        rect = clickedElement.getBoundingClientRect();
        // console.log(clickedElement,"clickedElement")
        // console.log(rect,"rect")
        // console.log(rect.left,"rect.left")
        // console.log({top:rect.left,left:rect.bottom})
        // console.log("passed last")
      }
      if (setClientCoord)
        setClientCoord({
          top: Math.ceil(rect.top + rect.height),
          left: rect.left,
          element: rect,
        });
      if (item?.[columnKey]?.type !== "person") {
        try {
          //  await fetchtableBodyData(item[columnKey]?.field_name);
          await fetchtableBodyData(columnKey?.column?.id ? columnKey?.column?.id : columnKey);
        } catch (error) {
          console.error("Error fetching customer data:", error);
        }
      }
    },
    [user.token, fetchtableBodyData]
  );

  return {
    handleDataInput,
  };
};

export default useDataInputHandlerCopy;
